module.exports = __webpack_public_path__ + "static/media/ic_premium_onboarding_small.4a261661.svg";